<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :defaultActiveKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label>Transaction Date</label>
                  <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="transactionDt"
                    :format="dateFormat" />
                </div>
                <div class="m-form-item-wrapper">
                  <label>Category</label>
                  <a-select placeholder="Ex: Value's < 100 Million Rupiah" v-model="kategori" class="width-full"
                    initialValue="null" allowClear>
                    <a-select-option value="less">Value's &#60; 100 Million Rupiah</a-select-option>
                    <a-select-option value="over">Value's &#62;= 100 Million Rupiah</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label>Supplier</label>
                  <a-select showSearch v-model="supplier_nm" placeholder="Select Supplier Name" class="width-full"
                    initialValue="delivered" allowClear>
                    <a-select-option v-for="item in wo_supplier" :key="item" :value="item">{{ item }}</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label>Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" class="width-full" initialValue="delivered"
                    allowClear>
                    <a-select-option value="delivered">Delivered</a-select-option>
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process">On Process</a-select-option>
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                    <a-select-option value="transferred">Transferred</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label>Payment Status</label>
                  <a-select placeholder="Ex: Transferred ... " v-model="statusPembayaran" class="width-full"
                    initialValue="null" allowClear>
                    <a-select-option value="transferred">Transferred</a-select-option>
                    <a-select-option value="yet transferred">Not Transferred</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label>Delivery Status</label>
                  <a-select placeholder="Ex: Received ... " v-model="statusPengiriman" class="width-full"
                    initialValue="null" allowClear>
                    <a-select-option value="yet">Not Delivery</a-select-option>
                    <a-select-option value="process">On Process</a-select-option>
                    <a-select-option value="done">Received</a-select-option>
                    <a-select-option value="refunded">Refunded</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <a-spin tip="Your document is being processed, do not leave this page!" :spinning="loadings.tab">
        <DataList v-if="khususPurchasingGA" :loading="loading" title="PO List" :manifestLink="getManifestLink"
          :dataList="poSearch" :isMonitoring="true" :disabledCreateEditLink="true"/>
        <DataList v-else :loading="loading" title="PO List" :manifestLink="getManifestLink" :isMonitoringtabbed="true"
          :dataList="poSearch" dataListTitle="PO Transaction" :otherList="poSearch" otherListTitle="PO Refund payment"
          :disabledCreateEditLink="true">
          <div slot="slot_extra">
            <a-button type="primary" icon="download" @click="showExport()">Export</a-button>
          </div>
        </DataList>
      </a-spin>
    </a-col>

    <a-modal v-model="exporting.visible" @ok="handleExport">
      <span slot="title"> <a-icon type="download" />&nbsp;Export </span>

      <div class="m-form-item-wrapper">
        <a-form-model
          ref="formExport"
          :model="exporting.form"
          :rules="exporting.rules"
          class="steps-content m-flex1"
        >
          <a-form-model-item label="Transaction Date" prop="transactionDt">
            <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="exporting.form.transactionDt"
              :format="getDefaultDateFormat" />
          </a-form-model-item>
        </a-form-model>
      </div>

      <template slot="footer">
        <a-button key="submit" type="primary" class="m-width-full"
          @click="handleExport" :loading="exporting.loading">
          Submit
        </a-button>
      </template>
    </a-modal>
  </a-row>
</template>


<script>
import axios from "axios";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";
import _ from "lodash";

export default {
  name: "ListPO",
  mixins: [CurrencyFormat, GlobalMethod],
  data() {
    return {
      loading: true,
      dateFormat: "DD MMM YYYY",
      poList: [],
      basedList: [],
      search: undefined,
      tempList: "",
      kategori: undefined,
      status: undefined,
      transactionDt: [],
      form: this.$form.createForm(this),
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      wo_supplier: [],
      supplier_nm: undefined,
      statusPembayaran: undefined,
      statusPengiriman: undefined,
      activeTab: "list",
      loadings: {
        tab: false,
      },
      khususPurchasingGA: false,
      exporting:{
        visible: false,
        loading: false,
        form:{
          transactionDt: null
        },
        rules:{
          transactionDt: [{ required: true, message: 'Transaction Date is Required!', trigger: "change" }],
        }
      }
    };
  },
  mounted() {
    this.fetchData();
    Event.$on("callbackTab", this.clickTabed);
  },
  beforeDestroy() {
    Event.$off("callbackTab", this.clickTabed);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    poSearch() {
      var self = this;
      let outputData = this.poList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.kategori) {
        outputData = outputData.filter((item) => {
          return this.kategori == "less" ? item.estimated_valueRP < 100000000 : item.estimated_valueRP >= 100000000;
        });
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.status.toLowerCase().indexOf(self.status.toLowerCase()) >= 0
        );
      }

      if (self.transactionDt.length > 0) {
        let startDt = moment(self.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(self.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        outputData = outputData.filter(
          (obj) => obj.tgl_buat >= startDt && obj.tgl_buat <= endDt
        );
      }

      if (this.supplier_nm) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.supplier &&
            obj.supplier
              .toLowerCase()
              .indexOf(this.supplier_nm.toLowerCase()) >= 0
        );
      }

      if (this.statusPembayaran) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.statusPembayaran &&
            obj.statusPembayaran
              .toLowerCase() == this.statusPembayaran.toLowerCase()
        );
      }

      if (this.statusPengiriman) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.delivered_po_wo &&
            obj.delivered_po_wo
              .toLowerCase() == this.statusPengiriman.toLowerCase()
        );
      }

      return outputData;
    },
    getManifestLink() {
      if (localStorage.getItem("nvpn") === "/keuangan") {
        return "SpclPOManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/pimpro") {
        return "SpclPOManifestPimpro";
      } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
        return "SpclPOManifestAL";
      } else if (localStorage.getItem("nvpn") === "/purchasing") {
        return "SpclPOManifest_purchase";
      } else if (localStorage.getItem("nvpn") === "/direktur") {
        return "SpclPOManifestDir";
      } else if (localStorage.getItem("nvpn") === "/ga") {
        return "SpclPOManifestGA";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        return "SpclPOManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclPOManifestVpf";
      } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
        return "SpclPOManifestFin";
      } else {
        return "SpclPOManifest_";
      }
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + (this.activeTab == 'list' ? "monitoring/po" : "po/po_refund"),
        params: {
          id: localStorage.getItem("nvky"),
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.khususPurchasingGA = response.data.divisi == "other" ? true : false;
          this.basedList = response.data.data;
          _.forEach(response.data.data, (data) => {
            this.poList.push({
              title: data.no_po + " | " + data.tlc_pembuat,
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              subdesc: [
                data.no_pp,
                { deskripsi: data.deskripsi },
                data.supplier,
                this.formatCurrency(data.mata_uang, data.estimated_value),
              ],
              status: data.status,
              id: data.id_po,
              cancelStatus: data.cancel_sts,
              receiveStatus: data.delivered,
              supplier: data.supplier,
              peruntukan: data.peruntukan,
              tgl_buat: data.tgl_buat,
              searchQ:
                data.no_pp +
                " " +
                data.no_po +
                " " +
                data.estimated_value +
                " " +
                data.deskripsi +
                " " +
                data.mata_uang +
                " " +
                data.tlc_pembuat,
              estimated_valueRP: data.estimated_valuerp,
              delivered_po_wo: data.delivered,
              closed_po_wo: data.close_sts,
              statusPembayaran: data.transfer_sts.toLowerCase() == 'transferred' ? "transferred" : "yet transferred",
            });
          });

          this.poList.forEach((element) => {
            if (this.wo_supplier.indexOf(element.supplier) === -1) {
              this.wo_supplier.push(element.supplier);
            }
          });
          this.loading = false;
          this.loadings.tab = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.loadings.tab = false;
            this.displayMessage("empty-db");
          }
        });
    },
    clickTabed(val) {
      this.activeTab = val;
      this.loadings.tab = true;
      this.poList = [];
      this.fetchData();
      this.resetFilter();
    },
    resetFilter() {
      this.search = null;
      this.kategori = null;
      this.status = null;
      this.supplier_nm = null;
      this.statusPembayaran = null;
      this.statusPengiriman = null;
      this.transactionDt = [];
    },
    showExport(){
      this.exporting.form.transactionDt = null
      this.exporting.visible = true
    },
    handleExport(){
      this.$refs.formExport.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        const start_dt = moment(this.exporting.form.transactionDt[0]).format(this.getStandartFormatDate)
        const end_dt   = moment(this.exporting.form.transactionDt[1]).format(this.getStandartFormatDate)
        this.exporting.loading = true
        this.asyncAxiosGet("po/export",
          this.getAuth,
          {
            start_date: start_dt,
            end_date: end_dt,
          }
        ).then((res) => {
          let data_export = [];

          res.data.forEach((item,index)=> {
            data_export.push({
              "No." : index+1,
              "No. PO" : item.no_po,
              "TLC" : item.user_create,
              "Project Code" : item.kode_project,
              "No. PP" : item.no_pp,
              "QC" : item.inc_qc=='1' ? 'Yes' : 'No',
              "Supplier" : item.nama_supplier,
              "Document COC" : item.coc=='1' ? 'Yes' : 'No',
              "Location" : item.lokasi,
              "Description" : item.deskripsi,
              "Currency" : item.currency,
              "Value PO" : item.value_po,
              "Note" : item.catatan,
              "Create Date" : moment(item.tgl_buat).format(this.getStandartFormatDate),
              "Due Date" : moment(item.due_date).format(this.getStandartFormatDate),
              "Delivery Date" : moment(item.delivery_date).format(this.getStandartFormatDate),
              "Receive Date" : moment(item.receive_date).format(this.getStandartFormatDate),
              "Status" : item.last_status,
            })
          })
          const workbook = this.$XLSX.utils.book_new();
          const worksheet = this.$XLSX.utils.json_to_sheet(data_export);
          /* Calculate maximum width for each column :: auto width*/
          // const columnSizes = data_export.reduce((acc, row) => {
          //   Object.keys(row).forEach((key, i) => {
          //     const headertextLength = key.length;
          //     const rowtextLength = row[key].toString().length
          //     const value = row[key] ? (headertextLength > rowtextLength ? headertextLength : rowtextLength) : 0;
          //     if (!acc[i] || value > acc[i]) {
          //       acc[i] = value;
          //     }
          //   });
          //   return acc;
          // }, []);
          // worksheet['!cols'] = columnSizes.map(width => ({ wch: width + 2 }));

          this.$XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          this.$XLSX.writeFile(workbook, "PO_"+start_dt+"_"+end_dt+".xlsx");

          this.exporting.loading = false
          this.exporting.visible = false
        }).catch(() => {
        });
      })
    }
  },
};
</script>